var map = {
	"./de_DE.json": 1309,
	"./en_AU.json": 1310,
	"./en_CA.json": 1311,
	"./en_GB.json": 1312,
	"./es_AR.json": 1313,
	"./es_ES.json": 1314,
	"./es_MX.json": 1315,
	"./fr_CA.json": 1316,
	"./fr_FR.json": 1317,
	"./it_IT.json": 1318,
	"./nl_NL.json": 1319,
	"./pt_BR.json": 1320,
	"./pt_PT.json": 1321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1308;